// Angular
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
// NgBootstrap
import {NgbDropdownModule, NgbNavModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
// Perfect Scrollbar
// import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
// Core module
import { CoreModule } from '../../core/core.module';

// Layout partials
import {
	LanguageSelectorComponent,
	NotificationComponent,
	ScrollTopComponent,
	SplashScreenComponent,
	StickyToolbarComponent,
	Subheader4Component,
	UserProfile3Component,
	MyLeaderComponent,
    DownloadManualComponent,
} from './layout';
// General
import { PortletModule } from './content/general/portlet/portlet.module';
// Errpr
import { ErrorComponent } from './content/general/error/error.component';

// SVG inline
import { InlineSVGModule } from 'ng-inline-svg-2';
import { TranslateModule } from '@ngx-translate/core';
import { StringFormatPipe } from '../../core/_base/layout/pipes/string-format.pipe';
import { FirstLetterPipe } from '@app/core/_base/layout';

@NgModule({
	declarations: [
		ScrollTopComponent,

		// topbar components
		ScrollTopComponent,
		SplashScreenComponent,
		StickyToolbarComponent,
		Subheader4Component,
		// LanguageSelectorComponent,
		// NotificationComponent,
		// UserProfile3Component,
		MyLeaderComponent,

		DownloadManualComponent,

		// ErrorComponent,
	],
	exports: [
		PortletModule,
		ScrollTopComponent,

		// topbar components
		ScrollTopComponent,
		SplashScreenComponent,
		StickyToolbarComponent,
		Subheader4Component,
		// LanguageSelectorComponent,
		// NotificationComponent,
		// UserProfile3Component,
		MyLeaderComponent,

		// ErrorComponent,
	],
	imports: [
		CommonModule,
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		// PerfectScrollbarModule,
		InlineSVGModule,
		CoreModule,
		PortletModule,

		// angular material modules
		MatButtonModule,
		MatMenuModule,
		MatSelectModule,
		MatInputModule,
		MatTableModule,
		MatAutocompleteModule,
		MatRadioModule,
		MatIconModule,
		MatNativeDateModule,
		MatProgressBarModule,
		MatDatepickerModule,
		MatCardModule,
		MatPaginatorModule,
		MatSortModule,
		MatCheckboxModule,
		MatProgressSpinnerModule,
		MatSnackBarModule,
		MatTabsModule,
		MatTooltipModule,
		MatDialogModule,
		MatBadgeModule,

		// ng-bootstrap modules
		NgbDropdownModule,
		NgbNavModule,
		NgbTooltipModule,
		// Translation
		TranslateModule.forChild(),
	],
	providers: [
		StringFormatPipe
	],
})
export class PartialsModule {
}
